import {React, pluralize, utils, Fragment} from '@api'
import {ProductLikeDefinition} from '@api/graphql'
import {PDFComponents} from '@modules/pdf/templates/vlp/VlpProductCard.styles'
import {LineItemLeft} from '@modules/pdf/templates/ysl/product/YslProductCard.styles'
import {Link} from '@react-pdf/renderer'
import {VlpProductCard, VlpSpecCardPdf, LangAwareText, usePdfStore} from '@modules/pdf'
import {
  ProductPageStyledComponents
} from './VlpProductPage.styles'
import {GroupByGrouping} from '@stores'
import logoImage from './images/centric_logo.png'
import {FILTER_UNASSIGNED_ID, useStores} from '@design-board/components'
import {VersionText} from '../ysl/product/YslProductPage.styles'

const heirarchy = ['Season', 'Category 1', 'Category 2', 'Collection']
export const FilterTextFooter: React.FC<{ download?: boolean }> = ({download}) => {
  let filterExtract = useFilterExtracts(true)
  const stores = useStores(),
    {workspaces: {workspaceConfig: config}, catalog: {hasLoadedConfig, settings: {freezeIds}}, filter: {hasFilterTerms}} = stores,
    colors = (hasFilterTerms && hasLoadedConfig && freezeIds.length) ? freezeIds.length === 1 ? config?.itemName : pluralize(config?.itemName) : '',
    totalFilterCount = colors ? filterExtract.count + 1 : filterExtract.count,
    {FiltersText, AttributeText} = ProductPageStyledComponents(),
    {LineItemLink} = PDFComponents(stores)
  let countText = totalFilterCount > 0 ? <LangAwareText textRenderer={AttributeText}> Filters ({totalFilterCount}) -</LangAwareText> : null

  let productViewQueryParams = Object.assign({}, stores.nav.queryParams)
  //  pdf properties
  let prodUrl = window.origin + stores.nav.urlString(stores.nav.urlFor({queryParams: productViewQueryParams}))
  // console.log(prodUrl)

  let filterText = _.trim(
    _.map(filterExtract.filters, (filterArr, attribute) => {
      return attribute + ` (${filterArr.length}) ` + _.trim(_.join(filterArr, ', '), ', ')
    }).join('; '), '; ')
  let filterTextAbstract = _.trim(
    _.map(filterExtract.filters, (filterArr, attribute) => {
      return attribute + ` (${filterArr.length})`
    }).join('; '), '; ')

  if (colors) {
    const colorText = `${(totalFilterCount > 1 ? '; ' : '') + colors} (from selection)`
    filterText += colorText
    filterTextAbstract += colorText
  }
  return (
    <Fragment>
      {countText}
      {download ? <LineItemLink src={prodUrl} style={{textDecoration: 'none'}} wrap={false}>
                  <LangAwareText textRenderer={FiltersText} fontSize={12} font='normal 12pt arial'>
                    {utils.getTextWidth(filterText, 'normal 12pt arial') < 1110 ? filterText : filterTextAbstract}
                  </LangAwareText>
                </LineItemLink> :
       <LangAwareText textRenderer={FiltersText} fontSize={12} font='normal 12pt arial' style={{minHeight: 12}}>
         {utils.getTextWidth(filterText, 'normal 12pt arial') < 1110 ? filterText : filterTextAbstract}
       </LangAwareText>}
    </Fragment>)
}

export const ProductPageHeader: React.FC = ({}) => {
  const {limitedCount, itemCount, breadcrumbData, hierarchy: {hideBreadcrumb}, versions, config: {showLogo, header: {show}, showTotalCount, queryLimit, logos}, headerImage, selectedLogo} = usePdfStore(),
    {HeaderView, BrandView, BrandLogo, HeaderHierarchy} = ProductPageStyledComponents()
  // const breadcrumbData: Array<any> = customer?.name === 'ASICS' ? [plan, folderName, collection] : _.map(seasonal, s => s && s.name).filter(b => b);
  let headerTitle: string = breadcrumbData.filter(b => b).join(' > ')
  if (!headerTitle) {
    let filterExtract = useFilterExtracts(false)
    let ordering = {}
    heirarchy.forEach((element, index) => ordering[heirarchy[index]] = index)
    const orderedFilter = Object.keys(filterExtract.filters).sort((arg1, arg2) => ordering[arg1] - ordering[arg2])
      .reduce((obj, key) => {
          obj[key] = filterExtract.filters[key]
          return obj
        }, {}
      )

    let filterText = _.trim(
      _.map(orderedFilter, (filterArr) => {
        return _.trim(_.join(filterArr, ', '), ', ')
      }).join(' > '), ' > ')

    headerTitle = utils.getTextWidth(filterText, '9pt') < 900 ? filterText.toUpperCase() :
                  Object.keys(orderedFilter).map(element => ` (${orderedFilter[element].length}) `).join(' > ')
  }
  if (showTotalCount) headerTitle += limitedCount && limitedCount !== itemCount ? ` (${limitedCount} / ${itemCount})` : ` (${queryLimit < itemCount ? `${queryLimit} / ` : ''}${itemCount})`
  let logo = headerImage ? require(`${headerImage}`) : logoImage

  if (logos && _.isArray(logos)) {
    const logoObj = _.find(logos, ['name', selectedLogo])
    logo = logoObj?.path ? require(`${logoObj.path}`) : logo
  }
  return <HeaderView>
    {show && <BrandView>
		<BrandLogo src={logo}/>
	</BrandView>}
    {!hideBreadcrumb && <HierarchyHeaderView showLogo={show}>
      {versions?.length ? <VersionText>{`${versions.join(', ')} | `}</VersionText> : null}
		<HeaderHierarchy>{`${headerTitle}`}</HeaderHierarchy>
	</HierarchyHeaderView>}
  </HeaderView>
}

export const ProductPageFooter: React.FC<{ index?: number, download?: boolean }> = ({index, download}) => {
  const {timeStamp, selectedPdfDocument: {brand}, config: {showFilters, logos, showLogo}, selectedLogo, footerImage} = usePdfStore(),
    {
      Left, Right, BrandNameText, Footer, PageNumberText, FilterFooter, CurrentDateText, BrandView, BrandLogo
    } = ProductPageStyledComponents(),
    footerLogo = footerImage ? require(`${footerImage}`) : null
  return <Footer>
    <Left>
      {showLogo && !footerLogo ? <BrandNameText>{logos && _.isArray(logos) ? selectedLogo : brand} </BrandNameText> : null}
      {footerLogo && <BrandView>
		  <BrandLogo src={footerLogo}/>
	  </BrandView>}
      <CurrentDateText>{timeStamp}</CurrentDateText>
    </Left>
    <Right>
      {
        showFilters ?
        <FilterFooter>
          <FilterTextFooter download={download}/>
        </FilterFooter>
                    : null
      }
      <PageNumberText>{index + 1}</PageNumberText>
    </Right>
  </Footer>
}

const HierarchyHeaderView = ({children, showLogo}) => {
  const {HierarchyView, OnlyHierarchyView} = ProductPageStyledComponents()
  return showLogo ? <HierarchyView>{children}</HierarchyView> : <OnlyHierarchyView>{children}</OnlyHierarchyView>
}

export const VlpProductPage: React.FC<{ index: number, products: ProductLikeDefinition[], group?: string, hideTitle?: boolean, children?, download?: boolean }> = ({children, products, index, download}) => {
  const {itemsPerRow, selectedPdfDocument: {orientation, size}} = usePdfStore(),
    {CardContainer, Products, ProductRow, MyReportPage} = ProductPageStyledComponents()

  return (
    <MyReportPage size={size} orientation={orientation ?? 'landscape'} hideTitle wrap={false} /*ruler={DEBUG} rulerSteps={8}*/ >
      {children ? children : <Fragment>
        <ProductPageHeader/>
        <Products>
          {_.chunk(products, itemsPerRow).map((productsForRow, row) =>
            <ProductRow key={row}>
              {productsForRow.map((p, c) => {
                return <CardContainer key={c}>
                  <ProductPerRow download={download} product={p}/>
                </CardContainer>
              })}
            </ProductRow>)}
        </Products>
        <ProductPageFooter index={index} download={download}/>
      </Fragment>}
    </MyReportPage>
  )
}

const _getImages3d: (product: any) => Array<string> = (product) => {
  const {catalog: {offlineItemsByIndex}} = useStores()
  const imagesIndex = offlineItemsByIndex['vlp-3d-images']
  if (imagesIndex) {
    const {style} = product
    if (!style?.colorways || !_.isArray(style?.colorways)) return []
    return style?.colorways?.reduce((acc, {exId}) => {
      const offline = imagesIndex[`${product.exId}_${exId}`]
      if (offline) {
        acc.push(...offline.images3d)
      }
      return acc
    }, [])
  }
  return []
}

export const ProductPerRow: React.FC<{ product: ProductLikeDefinition, group?: GroupByGrouping, download: boolean, columnSize?: number, onlyTitle?: boolean, height?: number, width?: number }> = ({product, group, download, columnSize, onlyTitle, height, width}) => {
  const stores = useStores(),
    {nav: {urlForObject}, catalog} = stores,
    {cardWidth, cardView: {one_mpv_row, _3d_images}} = usePdfStore(),
    {OneRowImageContainer} = ProductPageStyledComponents(),
    {ProductImage} = PDFComponents(stores),
    id = catalog.idFor(product),
    renderCatalogItem = (product) => product.spec ? <VlpSpecCardPdf key={id} group={group} width={width} height={height} columnSize={columnSize} onlyTitle={onlyTitle} spec={product}/>
                                                  : <VlpProductCard key={id} data={product} download={download}/>
  return one_mpv_row ? <OneRowImageContainer>
                       {renderCatalogItem(product)}
                       {_3d_images === true && _getImages3d(product).slice(0, 4).map((image: string, i: number) => {
                         return <ProductImage width={cardWidth} style={{marginBottom: 'auto', marginTop: '0', alignSelf: 'flex-start'}} key={`${image}_${id}`} src={image}/> // <Image key={i} source={image} style={{ objectFit: 'contain', width: 120
                         // }} />
                       })}
                     </OneRowImageContainer>
                     : <>{renderCatalogItem(product)}</>
}

export const useFilterExtracts = (isFooter): { filters: any, count: number } => {
  const stores = useStores(),
    {state: {groups}} = stores.filter
  let filterCount = 0
  let filterObj = {}
  _.keys(groups)
    .filter(g => groups[g]?.selected.size && !isFooter ? (heirarchy.map(e => (e.split(' ').join('').toLocaleLowerCase())).indexOf(g) != -1)
                                                       : (heirarchy.map(e => (e.split(' ').join('').toLocaleLowerCase())).indexOf(g) == -1)).map((key) => {
    const group = groups[key]
    const {catalog: {_fieldByName}} = stores
    const updatedDef = _fieldByName[key]

    const label = function (value: any, type) {
        let label
        if (value === FILTER_UNASSIGNED_ID) {
          label = type === 'Boolean' ? 'No' : 'None'
        } else {
          label = type === 'Boolean' ? String(value).replace(/true/g, 'Yes').replace(/false/g, 'No') : value
        }
        return {
          label,
          id: value
        }
      },
      values = () => {
        return updatedDef ? Array.from(group.selected.keys()).map(v => {
          return label(v, updatedDef.def?.type)
        }) : Array.from(group.selected.values()).filter(_.identity)
      },
      filterTitle = () => {
        const {selected: {size}} = group
        return key == 'collectionVersion' ? 'Seasons' : updatedDef ? (size > 1 ? updatedDef.def?.displayName?.plural : updatedDef.def?.displayName?.singular) || updatedDef?.label || updatedDef?.field
                                                                   : key == 'vlpProduct' ? 'Products' : key == 'collectionVersion' ? 'Seasons' : _.capitalize(key)
      }
    values().forEach((filterItem) => {
      filterCount++
      const item = filterItem
      let filterName: string
      let title = filterTitle()
      filterName = _.toString((title === 'Tag') ? item.name : (title === 'Products' ? item?.merchProduct?.name : item.label))
      !filterName && (filterName = item.name || '')
      filterObj.hasOwnProperty(title) ? filterObj[title].push(filterName?.trim()) : filterObj[title] = [filterName?.trim()]
    })
  })
  return {filters: filterObj, count: filterCount}
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpProductPage.tsx